import {StyledBaseLayout, BaseLayoutHeadline} from "./styles";
import Logo from "../Logo";
import {FC} from "react";
import {Link} from "react-router-dom";

interface InspectBaseLayout {
    headline?: string
};

const BaseLayout: FC<InspectBaseLayout> = ({headline, children, ...others}) => {
    return (
        <StyledBaseLayout {...others}>
            {headline && <BaseLayoutHeadline>{headline}</BaseLayoutHeadline>}
            {children}
        </StyledBaseLayout>
    );
};

export default BaseLayout;
